export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/pyodide.worker.1a289ddf.js");
}
